import React, { FC } from 'react';
import { EmptyState } from 'common/components';
import { CatalogHeader } from 'entities/Catalog/components';

interface IComponentProps {}

export const CatalogEmpty: FC<IComponentProps> = () => {
  return (
    <div className="redesign relative pt-11 px-11 h-full flex direction-column">
      <CatalogHeader />

      <EmptyState title="Каталог не найден" description="Обратитесь в поддержку" />
    </div>
  );
};
